"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Input = _interopRequireDefault(require("./Input"));
var _TextArea = _interopRequireDefault(require("./TextArea"));
var _Select = _interopRequireDefault(require("./Select"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
var SalesforceContactForm = function SalesforceContactForm() {
  return /*#__PURE__*/_react["default"].createElement("form", {
    action: "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
    method: "POST"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "hidden",
    name: "oid",
    value: "00D0Y000002IW98"
  }), /*#__PURE__*/_react["default"].createElement("input", {
    type: "hidden",
    name: "retURL",
    value: "https://www.theyachtweek.com/contact-confirm"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 col-sm-8 off-sm-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "well relative",
    style: {
      padding: 40
    }
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "tac mb10"
  }, "Contact us"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "tac mb30"
  }, "Get in touch using the form below"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 col-sm-4 off-sm-2"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    placeholder: "First name",
    name: "first_name",
    id: "first_name",
    label: "First name",
    type: "text"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 col-sm-4"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    placeholder: "Last name",
    name: "last_name",
    id: "last_name",
    label: "Last name",
    type: "text"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 col-sm-4 off-sm-2"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    name: "email",
    type: "email",
    id: "email",
    placeholder: "Email",
    label: "Email"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 col-sm-4"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    name: "phone",
    id: "phone",
    type: "phone",
    placeholder: "Phone",
    label: "Phone"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 col-sm-8 off-sm-2"
  }, /*#__PURE__*/_react["default"].createElement(_TextArea["default"], {
    id: "00N1v00000Sjug5",
    name: "00N1v00000Sjug5",
    type: "text",
    placeholder: "When are you looking to travel?",
    label: "When are you looking to travel?"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 col-sm-8 off-sm-2"
  }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    id: "00N1v00000Sjug0",
    name: "00N1v00000Sjug0",
    label: "What route are you interested in?",
    placeholder: "--None--",
    options: ['Croatia, Original Route', 'Croatia, Ultra Route', 'Croatia, Dubrovnik Route', 'Greece, Athens Route', 'Montenegro, Adriatic Route', 'Caribbean, BVI Route', 'Not sure yet'].map(function (o) {
      return {
        value: o,
        text: o
      };
    })
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 col-sm-8 off-sm-2"
  }, /*#__PURE__*/_react["default"].createElement(_TextArea["default"], {
    placeholder: "Anything else?",
    id: "00N1v00000SjugA",
    name: "00N1v00000SjugA",
    type: "text",
    label: "Anything else?"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12 col-sm-4 off-sm-4"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    text: "Submit",
    buttonType: _constants.BUTTON_TYPES.PRIMARY,
    buttonSize: "btn--md"
  }))));
};
var _default = exports["default"] = SalesforceContactForm;